import { render } from "./HomeCard.vue?vue&type=template&id=a95ef12c&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"

import "./HomeCard.vue?vue&type=style&index=0&id=a95ef12c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95ef12c"]])

export default __exports__